import React, {
  useMemo,
  Fragment,
  useState,
  useEffect,
  useContext,
} from "react";
import { MaterialReactTable } from "material-react-table";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { useOutletContext } from "react-router-dom";

const AccountAdminTable = ({ tableData, setTableData, rhfFormInstance,setWasAdminEdited  }) => {
  /**
        adminId: "5d9c763a-f682-4ccf-ad24-fd4c9e825c7a"
        emailAddress: "sampletest1@manpowergroup.com"
        firstName: "Gayathri"
        lastName: "Karanam"
        permissionRole: "Admin"
        permissionRoleDescription: "Admin"
     */
  const { refClientAccountCmsData } = useOutletContext();
  const { setValue, trigger } = rhfFormInstance;
  const fetchAccountAdminCmsData = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"]
    ) {
      const adminClientSubAccountCmsDataLabel =
        refClientAccountCmsData?.Components["ClientAccounts.AccountAdmins"];
      return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key);
    }
    return "";
  };
  const fetchCommonComponentCMSLabel = (key) => {
    if (
      refClientAccountCmsData?.Components &&
      refClientAccountCmsData?.Components["CommonComponent"]
    ) {
      const commonComponentLabel =
        refClientAccountCmsData?.Components["CommonComponent"];
      return returnLabel(commonComponentLabel?.Labels, key);
    }
    return "";
  };
  

  const returnLabel = (labelArray = [], key) => {
    return labelArray.find((x) => x.Key === key)?.Phrase || "";
  };

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => `${row.firstName} ${row.lastName}`,
        id: "fullName",
        header: fetchAccountAdminCmsData("AccountAdmins.Name"),
        filterFn: "contains",
      },
      {
        accessorKey: "emailAddress",
        header: fetchAccountAdminCmsData("AccountAdmins.Email"),
        filterFn: "contains",
      },
      {
        accessorFn: (row) =>
          `${row.permissionRole} - ${row.permissionRoleDescription}`,
        id: "permissionLevel",
        header: fetchAccountAdminCmsData("AccountAdmins.PermissionLevel"),
        filterFn: "contains",
      },
    ],
    []
  );

  const removeAccountAdminTableEntry = ({ idToBeRemoved }) => {
    const newList =
      !!tableData &&
      tableData.filter((item) => {
        if (item.adminId !== idToBeRemoved) {
          return item;
        }
      });
    setTableData(newList);
    setWasAdminEdited(true);
    setValue("accountAdmins", newList, { shouldValidate: true });
    trigger("accountAdmins");
  };

  return (
    <MaterialReactTable
      columns={columns}
      data={tableData || []}
      layoutMode="grid"
      enableGlobalFilter={false}
      enableDensityToggle={false}
      muiTablePaginationProps={{
        labelRowsPerPage: fetchCommonComponentCMSLabel("Common.Rowsperpage"),
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: fetchAccountAdminCmsData("AccountAdmins.Actions"),
        },
        "mrt-row-drag": {
          header: fetchAccountAdminCmsData("AccountAdmins.Move"),
        },
      }}
      enableTopToolbar={!!tableData && tableData.length ? true : false}
      enableBottomToolbar={!!tableData && tableData.length ? true : false}
      initialState={{
        density: "compact",
      }}
      /** !!!!!!!!!! row actions !!!!!!!!!! */
      enableRowActions
      renderRowActions={({ row, table }) => {
        return (
          <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
            <IconButton
              onClick={() => {
                const AdminId = row.original.adminId;
                removeAccountAdminTableEntry({ idToBeRemoved: AdminId });
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      }}
    />
  );
};
export default AccountAdminTable;
